import React, { useState } from 'react';
import { MutationDefinition, BaseQueryFn } from '@reduxjs/toolkit/dist/query';
import { MutationTrigger } from '@reduxjs/toolkit/dist/query/react/buildHooks';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { SendTokenResponse, UserParams, useSendTokenMutation } from 'services/api/users';
import { handleApiError } from 'helper/error';
import { ResponseError } from 'services/api/base';
import ActionButton from 'components/ActionButton';
import Dialog from 'components/DesignSystem/Dialog';
import DialogBody from 'components/DesignSystem/Dialog/Body';
import DialogFooter from 'components/DesignSystem/Dialog/Footer';
import Button from 'components/DesignSystem/Button';

export const onClick = async (
  sendToken: MutationTrigger<MutationDefinition<
  UserParams,
  BaseQueryFn<unknown>,
  never,
  SendTokenResponse,
  'api'
  >>,
  userId: number,
  navigate: NavigateFunction,
  setDialogOpen: (value: boolean) => void,
) => {
  const response = await sendToken({ user_id: userId });
  if ('error' in response) {
    handleApiError(navigate, response.error as ResponseError);
  } else {
    setDialogOpen(true);
  }
};

export default function SendTokenButton({ userId }: { userId: number }) {
  const [sendToken, { isLoading: loading }] = useSendTokenMutation();
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <div className="ms-2 me-1 h-100 d-flex align-items-center">
      <Dialog
        open={dialogOpen}
        closeButton
        dismiss={() => setDialogOpen(false)}
        type="success"
      >
        <DialogBody>
          O token foi enviado com sucesso.
        </DialogBody>
        <DialogFooter>
          <Button onClick={() => setDialogOpen(false)}>Ok</Button>
        </DialogFooter>
      </Dialog>
      <ActionButton
        icon="send"
        loading={loading}
        onClick={() => onClick(sendToken, userId, navigate, setDialogOpen)}
        tooltipText="Enviar token por e-mail"
        id={`user-send-token-${userId}`}
      />
    </div>
  );
}
